import { themeOptionFactory as MobileThemeOptionFactory } from "./app-mobile.theme"
import { themeOptionFactory as KiokVthemeOptionFactory } from "./app-v-standard.theme"
import { themeOptionFactory as KiokHthemeOptionFactory } from "./app-h-standard.theme"
export const appThemeOptionFactory = {
  mobile: MobileThemeOptionFactory,
  "kiosk-v": KiokVthemeOptionFactory,
  "kiosk-h": KiokHthemeOptionFactory,
}
